import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=6b81ca26&scoped=true"
import script from "./Document.vue?vue&type=script&lang=js"
export * from "./Document.vue?vue&type=script&lang=js"
import style0 from "./Document.vue?vue&type=style&index=0&id=6b81ca26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b81ca26",
  null
  
)

export default component.exports